export enum MessageResponse {
  CREATED = 'Created',
  OK = 'OK',
  UPDATED = 'Updated',
  DELETED = 'Deleted'
}

export interface IResponseStatus {
  error: string;
  data: {
    data?: {
      id?: string;
    };
    message: MessageResponse;
  };
}
